import { reportDarkPalette } from "assets/jss/material-dashboard-react.jsx";
import { getAppThemeMode } from "theme/appTheme.js";

export const isReportDarkUi = () => getAppThemeMode() === "dark";

export const getReportChartUi = () => {
  const dark = isReportDarkUi();
  return {
    title: dark ? reportDarkPalette.text : "#2c3e50",
    axisLabel: dark ? reportDarkPalette.textMuted : "#7f8c8d",
    axisLine: dark ? reportDarkPalette.stroke : "#d5dbdb",
    tooltipBg: dark ? reportDarkPalette.elevated : "#6a7985",
    cardTitle: dark ? reportDarkPalette.text : "#273746",
    cardIcon: dark ? reportDarkPalette.textMuted : "#3C4858",
    mutedText: dark ? reportDarkPalette.textMuted : "#566573",
    inputBorder: dark ? reportDarkPalette.stroke : "#d5d8dc",
    inputText: dark ? reportDarkPalette.text : "#273746",
    bill: dark ? reportDarkPalette.orange : "#c0392b",
    co2: dark ? reportDarkPalette.green : "#16a085",
    missed: dark ? "#f39c12" : "#f39c12"
  };
};
